export default function Features() {
  const features = [
    {
      icon: 'ri-graduation-cap-fill',
      title: 'Certificación Oficial',
      description: 'Obtén tu certificado de profesionalidad según RD 545/2023, nivel de cualificación 2, reconocido en toda España y Europa.'
    },
    {
      icon: 'ri-video-fill',
      title: 'Aula virtual de Formación Online Completa',
      description: 'Accede a contenido multimedia de alta calidad con vídeos paso a paso, fotografías detalladas y material didáctico profesional.'
    },
    {
      icon: 'ri-user-star-fill',
      title: 'Tutores Expertos',
      description: 'Aprende de profesionales en formación continua y con certificados de Profesionalidad, con años de experiencia en adiestramiento canino y educación colaborativa y respetuosa.'
    },
    {
      icon: 'ri-calendar-check-fill',
      title: 'A tu Ritmo',
      description: 'Con el Aula Virtual estudia cuando quieras y desde donde quieras. Contenido disponible las 24 horas con acceso ilimitado durante tu formación.'
    },
    {
      icon: 'ri-file-list-3-fill',
      title: 'Evaluación Continua',
      description: 'Cuestionarios interactivos y evaluaciones prácticas para asegurar tu progreso y comprensión de cada módulo formativo.'
    },
    {
      icon: 'ri-community-fill',
      title: 'Comunidad Activa',
      description: 'Únete a una comunidad de estudiantes y profesionales donde compartir experiencias, dudas y casos prácticos reales.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            ¿Por Qué Elegir "El Aula Virtual de Formación" de Aula K9?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nuestra experiencia nos avala. Ofrecemos una formación integral y profesional en adiestramiento canino con metodología innovadora y certificación oficial que te abrirá las puertas al mundo profesional.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="w-14 h-14 bg-secondary-100 rounded-xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-secondary-600 text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
